import React from "react";

import { Box } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";

import { ReportJobAction } from "actions/reportJob";

import AgGridTable from "components/AgGrid/AgGridContainer";
import { Column } from "components/Layout";
import WaitForSync from "components/LoadingSpinner/WaitForSync";
import { TitleText } from "components/Text";

import { AgGridTables } from "constants/aggrid";
import { ReportJobColumnDef } from "constants/columnDefinitions/reportJob";
import { ApiModel } from "constants/loading";

import { getBusinesses, getSales } from "selectors";

import { selectReportJobAggridData } from "selectors/aggrid/reportJob";

import { useMountEffect } from "hooks";

const getRowId = ({ data }) => data.reportJob.id;

const columnDefs = Object.values(ReportJobColumnDef);

export const ReportJobList = () => {
  const dispatch = useDispatch();
  useMountEffect(() => {
    dispatch(ReportJobAction.request());
  });
  const businessByIdLookup = useSelector(getBusinesses);
  const saleByIdLookup = useSelector(getSales);
  const data = useSelector(selectReportJobAggridData);
  return (
    <Column fullHeight>
      <Box p={2}>
        <TitleText>Reports</TitleText>
      </Box>
      <AgGridTable
        columnDefs={columnDefs}
        getRowId={getRowId}
        rowData={data}
        tableName={AgGridTables.REPORT_JOB}
        context={{ businessByIdLookup, saleByIdLookup }}
      />
    </Column>
  );
};

export const ReportJobListWrapper = () => {
  return (
    <WaitForSync requiredData={[ApiModel.BUSINESSES, ApiModel.SALES]}>
      <ReportJobList />
    </WaitForSync>
  );
};
